import SiteNoticeLayout from "./components/SiteNotice/Component";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import { Toaster } from "react-hot-toast";
import DashboardComponent from "./dashboard/Dashboard/Component";
import Home from "./pages/Home";
import About from "./pages/About";
import Menu from "./pages/Menu";

const container = document.querySelector("#root");
if (!container) {
  throw new Error("Root element not found");
}
const root = createRoot(container);
const queryClient = new QueryClient();

const routes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/dashboard/*" element={<DashboardComponent />} />
        <Route
          path="/"
          element={
            <SiteNoticeLayout>
              <Home />
            </SiteNoticeLayout>
          }
        />
        <Route
          path="/about"
          element={
            <SiteNoticeLayout>
              <About />
            </SiteNoticeLayout>
          }
        />
        <Route
          path="/menu"
          element={
            <SiteNoticeLayout>
              <Menu />
            </SiteNoticeLayout>
          }
        />
      </Routes>
    </Router>
  );
};

root.render(
  <QueryClientProvider client={queryClient}>
    {routes()}
    <Toaster />
  </QueryClientProvider>
);
